import { useCurrentAccount } from "./useCurrentAccount";

/*
This hook should only be used when an account is selected
*/
export const useCanCreateTicket = (): boolean => {
  const account = useCurrentAccount();

  return !account.hasRestrictedAccess && !!account.manager?.id;
};
